import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  ConnectAccountToOpenSolarInput,
  ConnectAccountToOpenSolarMutation,
  DisconnectAccountFromOpenSolarMutation,
} from '../../../gql/graphql';

const CONNECT_ACCOUNT_TO_OPEN_SOLAR = graphql(`
  mutation ConnectAccountToOpenSolar($input: ConnectAccountToOpenSolarInput!) {
    connectAccountToOpenSolar(input: $input) {
      __typename
      ... on ConnectAccountToOpenSolarSuccess {
        id
      }
      ... on ConnectAccountToOpenSolarInvalidCredentials {
        code
        message
      }
      ... on ConnectAccountToOpenSolarTwoFactorCodeRequired {
        code
        message
      }
      ... on ConnectAccountToOpenSolarError {
        code
        message
      }
    }
  }
`);

export const useConnectAccountToOpenSolar = (
  options?: UseMutationOptions<
    ConnectAccountToOpenSolarMutation,
    unknown,
    ConnectAccountToOpenSolarInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CONNECT_ACCOUNT_TO_OPEN_SOLAR, {
        input,
      });
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: meKeys.integrations() }),
    ...options,
  });
};

const DISCONNECT_ACCOUNT_FROM_OPEN_SOLAR = graphql(`
  mutation DisconnectAccountFromOpenSolar {
    disconnectAccountFromOpenSolar
  }
`);

export const useDisconnectAccountFromOpenSolar = (
  options?: UseMutationOptions<
    DisconnectAccountFromOpenSolarMutation,
    unknown,
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return gqlClient.request(DISCONNECT_ACCOUNT_FROM_OPEN_SOLAR);
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: meKeys.integrations() }),
    ...options,
  });
};
